// components/SplitSection.jsx — Text left / Image right split section
import { SectionWrapper } from "./UI";

export default function SplitSection({ content, dark, lang }) {
  const isEs = lang === "es";

  const badge      = isEs ? (content?.badgeEs      || content?.badge)      : content?.badge      || "Design & Development";
  const heading    = isEs ? (content?.headingEs    || content?.heading)    : content?.heading    || "UI/UX Design & Frontend Development in Spain";
  const paragraph1 = isEs ? (content?.paragraph1Es || content?.paragraph1) : content?.paragraph1 || "";
  const paragraph2 = isEs ? (content?.paragraph2Es || content?.paragraph2) : content?.paragraph2 || "";
  const paragraph3 = isEs ? (content?.paragraph3Es || content?.paragraph3) : content?.paragraph3 || "";
  const image      = content?.image    || "https://images.unsplash.com/photo-1551650975-87deedd944c3?w=900&q=80";
  const imageAlt   = content?.imageAlt || "UI/UX Design and Frontend Development workspace";

  return (
    <SectionWrapper id="about" dark={dark} bg="alt">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[3fr_2fr] gap-12 lg:gap-20 items-center">
        <div className="flex flex-col gap-6">
          <div className=" inline-flex w-fit">
            <span className={`text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full border ${dark ? "border-[#A3E635]/40 text-[#A3E635] bg-[#A3E635]/10" : "border-[#A3E635]/60 text-[#5a7a00] bg-[#A3E635]/15"}`}>
              {badge}
            </span>
          </div>

          <h2 className=" text-3xl sm:text-4xl lg:text-[2.6rem] font-bold leading-tight tracking-tight">
            {heading.includes("&") ? (
              <>{heading.split("&")[0]}<span className="text-[#A3E635]">&amp;</span>{heading.split("&")[1]}</>
            ) : heading}
          </h2>

          <div className=" w-12 h-1 rounded-full bg-[#A3E635]" />

          {[paragraph1, paragraph2, paragraph3].map((p, i) => p ? (
            <p key={i} className={`text-base leading-relaxed ${dark ? "text-white/60" : "text-[#0F172A]/60"}`}>{p}</p>
          ) : null)}

          <div className=" grid grid-cols-3 gap-4 pt-2">
            {[
              { num: "50+", label: isEs ? "Proyectos" : "Projects" },
              { num: "5★",  label: isEs ? "Valoración" : "Rating" },
              { num: "3+",  label: isEs ? "Años Exp." : "Years Exp." },
            ].map(({ num, label }) => (
              <div key={label} className={`rounded-2xl p-4 text-center border ${dark ? "bg-white/5 border-white/10" : "bg-white border-[#E2E8F0]"}`}>
                <div className="text-2xl font-bold text-[#A3E635]">{num}</div>
                <div className={`text-xs mt-1 ${dark ? "text-white/40" : "text-[#0F172A]/40"}`}>{label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className=" relative">
          <div className="absolute -top-4 -right-4 w-full h-full rounded-3xl bg-[#A3E635]/20 -z-10" aria-hidden="true" />
          <img src={image} alt={imageAlt} loading="lazy" decoding="async" className={`w-full h-[420px] lg:h-[500px] object-cover rounded-3xl shadow-2xl ${dark ? "shadow-black/40" : "shadow-slate-300/60"}`} />
          <div className={`absolute bottom-6 left-6 right-6 rounded-2xl px-5 py-4 backdrop-blur-md flex items-center gap-3 ${dark ? "bg-[#0F172A]/80 border border-white/10" : "bg-white/85 border border-white/60"}`}>
            <div className="w-9 h-9 rounded-xl bg-[#A3E635] flex items-center justify-center text-lg shrink-0">💻</div>
            <div>
              <div className="text-sm font-semibold">React + Tailwind</div>
              <div className={`text-xs ${dark ? "text-white/45" : "text-[#0F172A]/45"}`}>
                {isEs ? "Limpio, escalable y rápido" : "Clean, scalable & fast"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}
